var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2501 42.0177C49.4349 42.0177 56.07 35.2146 56.07 26.8226C56.07 18.4305 49.4349 11.6274 41.2501 11.6274C33.0653 11.6274 26.4302 18.4305 26.4302 26.8226C26.4302 35.2146 33.0653 42.0177 41.2501 42.0177Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2183 27.6596C36.816 28.8761 37.7144 29.9107 38.8238 30.6601C39.9333 31.4094 41.215 31.8474 42.5411 31.9303C43.8635 31.9586 45.1583 31.541 46.2268 30.7418C47.2953 29.9425 48.0784 28.8056 48.4557 27.5059",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2061 26.2589C48.1811 26.1235 49.1711 26.3508 49.9968 26.8995",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6509 26.0024L34.6187 27.9926C35.6683 27.2922 36.6013 26.7028 37.6509 26.0024Z",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5311 24.2601C22.2582 24.004 21.0414 23.5119 19.9407 22.808C19.3911 22.4503 18.919 21.9806 18.5536 21.4282C18.1882 20.8758 17.9373 20.2523 17.8164 19.5965C17.722 19.0106 17.8217 18.4092 18.0997 17.8882C18.7161 16.812 20.1157 16.5643 21.3402 16.5301C25.2416 16.45 29.0992 17.3844 32.5531 19.2463C26.6051 12.4132 27.1299 6.86128 28.2712 5.74236C30.8286 3.17995 33.661 6.98086 34.3191 8.01437C35.8963 10.6687 37.0837 13.5467 37.8429 16.5557C38.3261 13.3271 39.3674 6.43421 42.2247 3.81201C42.642 3.43147 43.1508 3.17221 43.6986 3.06108C44.2464 2.94995 44.8132 2.99099 45.3403 3.17995C46.6982 3.70097 47.3563 5.29821 47.5313 6.76733C47.9561 10.3718 46.39 13.8738 44.8655 17.1451C47.1757 14.8092 49.8259 12.8556 52.7211 11.354C56.7031 9.36391 57.9943 11.3028 58.3775 12.0801C59.9353 15.2916 53.4292 21.3475 51.3966 23.1839C54.6288 22.6116 63.2592 24.3711 62.3678 28.3685C61.6847 31.4177 53.7375 31.3494 50.8634 31.4177C53.3626 32.4256 58.4359 35.7909 57.9027 38.8573C57.2862 42.4276 50.9051 39.9335 45.5153 34.8343C46.7565 36.5426 50.0387 43.6319 46.2317 45.5281C45.0571 46.1089 43.1411 45.0669 41.7332 43.1109C40.3254 41.1549 39.5507 38.3533 39.1008 35.8422C38.2678 40.6595 33.3861 48.1332 29.2958 46.0918C25.5055 44.2213 30.5621 35.5432 32.3948 32.6819C30.1622 35.1759 23.2313 39.0879 20.7321 36.8244C18.233 34.561 22.0067 28.5735 26.5634 26.1648C26.905 25.9769 28.8127 24.7725 28.8127 24.7725C28.8127 24.7725 24.6891 24.5334 23.5311 24.2601Z",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1426 37.4819C39.1426 37.4819 40.2839 49.1409 41.875 58.5791",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 54.5395C18.6661 54.5395 26.2135 54.6506 27.8879 54.3943C28.6627 54.2747 31.62 50.6788 33.7942 49.8503C35.9685 49.0218 37.1264 49.4659 38.2177 50.4482C41.7332 53.5743 41.0668 61.1762 40.5086 64.4475C40.5086 64.6013 40.0838 67.1637 38.376 67.0099C36.1268 66.7793 35.552 59.3227 35.3187 57.6144C35.1688 61.3555 34.1025 66.2839 31.4284 67.7274",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2422 53.0277C43.214 52.7792 46.2006 52.7792 49.1725 53.0277C54.2457 53.6683 55.1954 58.554 51.5633 59.8608C49.539 60.5954 44.749 61.0651 42.9163 60.2964C41.2502 59.6131 41.9583 57.3753 43.666 56.8201C46.9982 55.7353 48.606 55.9659 48.606 55.9659",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5129 59.9546C51.8964 60.0087 52.2556 60.1782 52.5451 60.4416C52.8346 60.7051 53.0415 61.0506 53.1396 61.4345C53.2376 61.8184 53.2225 62.2235 53.0961 62.5987C52.9696 62.9738 52.7376 63.302 52.4292 63.542C50.3133 65.4125 46.5063 65.3869 42.6909 64.9171",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8636 64.627C53.7459 66.4206 51.1301 68.966 48.5227 69.5553C46.6395 69.901 44.7079 69.8575 42.8413 69.4272",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8823 73.8601C46.3068 73.9626 51.0969 73.9113 51.1718 70.8364",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0239 74.2441C23.0229 74.2441 27.4797 73.8341 30.437 74.3637C33.1444 74.842 37.6512 77.3532 41.9997 75.2776",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPositive);
export default __webpack_public_path__ + "static/media/icon-positive.a08375372b3e6c8695cef209a3515974.svg";
export { ForwardRef as ReactComponent };